import React, { useState, useEffect } from "react";
import withLanguage from "../../../HOC/withLanguage";
import { Link, useNavigate } from "react-router-dom";

function SearchAndImages({ language }) {

    const [images, setImages] = useState([]);
    const [searchValue, setSearchValue] = useState("");
    const navigate = useNavigate();

    const noSearchValue = Boolean(!searchValue.trim())

    useEffect(() => {
        fetch("/api/dual_system/professional_dual_system/arsimi_profesional_homepage")
            .then((res) => res.json())
            .then((data) => {
                setImages(data.records);
            })
            .catch((err) => console.error("API fetch error:", err));
    }, []);

    const handleSearchSubmit = (e) => {
        e.preventDefault()
        if(noSearchValue) return
        navigate(`/search-result/?query=${searchValue}&isDual=true`);
    };

    return (

        <section>
            <div className="max-w-6xl mx-auto px-6 mt-16">
                <h2 className="text-center font-semibold text-2xl mb-4">
                    {language.secondTitle}
                </h2>
            </div>

            <div className="flex justify-center mb-[55px] max-w-5xl mx-auto">
                <form
                    onSubmit={handleSearchSubmit}
                    className="flex w-full max-w-5xl"
                >
                    <input
                        type="text"
                        placeholder={language.placeholder}
                        className="border border-red-300 px-4 py-2 w-full rounded-l-3xl focus:outline-none text-[17px]"
                        value={searchValue}
                        onChange={(e) => setSearchValue(e.target.value)}
                    />
                    <button
                        type="submit"
                        disabled={noSearchValue}
                        className={`bg-red-600 text-white px-6 rounded-r-2xl hover:bg-red-700 flex items-center justify-center ${noSearchValue ? 'opacity-85' : ''}`}
                        onClick={handleSearchSubmit}
                    >
                        {language.search}
                    </button>
                </form>
            </div>


            <div className="grid md:grid-cols-3 justify-center text-center max-w-[1100px] mx-auto mb-10">
                {/* Box 1 */}
                <div>

                    <Link to="/Nxenes%20Punemarres">
                        <button className="bg-red-600 text-white font-medium px-[85px] py-2 rounded-2xl hover:bg-red-700 mb-4">
                            {language.button1}
                        </button>
                    </Link>

                    {images[0]?.image && (
                        <div className="border-2 border-red-500 rounded-2xl mx-auto w-[279px]">
                            <div className=" flex items-center justify-center">

                                <img
                                    src={`data:image/jpeg;base64,${images[0]?.image}`}
                                    alt="API"
                                    className="bg-center bg-cover object-cover rounded-xl h-[200px]"
                                />

                            </div>
                        </div>
                    )}
                </div>


                {/* Box 2 */}
                <div>
                    <Link to="/Punedhenes">
                        <button className="bg-red-600 text-white font-medium px-[115px] py-2 rounded-2xl hover:bg-red-700 mb-4">
                            {language.button2}
                        </button>
                    </Link>

                    {images[1]?.image && (
                        <div className="border-2 border-red-500 rounded-2xl mx-auto w-[279px]">
                            <div className="flex items-center justify-center">
                                <img
                                    src={`data:image/jpeg;base64,${images[1]?.image}`}
                                    alt="API"
                                    className="bg-center bg-cover object-cover rounded-xl h-[200px]"
                                />
                            </div>
                        </div>
                    )}


                </div>



                {/* Box 3 */}
                <div>

                    <Link to="/KualifikimDual">
                        <button className="bg-red-600 text-white font-medium px-12 py-2 rounded-2xl hover:bg-red-700 mb-4">
                            {language.button3}
                        </button>
                    </Link>

                    {images[2]?.image && (
                        <div className="border-2 border-red-500 rounded-2xl mx-auto w-[279px]">
                            <div className="flex items-center justify-center">
                                <img
                                    src={`data:image/jpeg;base64,${images[2]?.image}`}
                                    alt="API"
                                    className="bg-center bg-cover object-cover rounded-xl h-[200px]"
                                />
                            </div>
                        </div>
                    )}
                </div>


            </div>
        </section>
    );
}

export default withLanguage(SearchAndImages, "SearchAndImages");